import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import ProgressLoadingBar from '../ProgressLoadingBar';
import { Icons } from '../Icons';
import { apiUrl } from '../UploadDocument/apiUrl';
/**
 *  A React component that renders a loading indicator.
 * if progress is not provided, it will render an infinite loading indicator
 * if progress is provided, it will render a progress bar
 * Optionally a textBlock can be provided to display a message
 */
function LoadingIndicatorProgress({ className, textBlock, progress }) {
  const [configuration, setConfiguration] = useState({ logo_secondary_base64: '' });
  useEffect(() => {
    const config = async () => {
      try {
        const response = await fetch(apiUrl + '/api/settings');
        const data = await response.json();

        setConfiguration(data);
      } catch (error) {
        console.error(error);
        return null;
      }
    }
    config();
  }, [])
  return (
    <div
      className={classNames(
        'absolute top-0 left-0 z-50 flex flex-col items-center justify-center space-y-5',
        className
      )}
    >
      <div className="ml-1 max-sm:hidden">
        <img
          src={configuration.logo_secondary_base64 ? configuration.logo_secondary_base64 : "/logo_med.png"}
          alt=""
          className="py-1"
          width={170}
        />
      </div>
      {/* <Icons.LoadingOHIFMark className="h-12 w-12 text-white" /> */}
      <div className="w-48">
        <ProgressLoadingBar progress={progress} />
      </div>
      {textBlock}
    </div>
  );
}

export default LoadingIndicatorProgress;
